<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="LS01_background">
        <div class="position">
          <div style="display: flex; flex-direction: column">
            <step-progress
              :steps="mySteps"
              :current-step="currentStep"
              icon-class="fa fa-check fa-lg"
            ></step-progress>
            <div class="card">
              <div class="container_CIT01">
                <div class="block">
                  <div class="btn-exit" @click="onClose">
                    <ButtonIcon
                      :iconUrl="`close.png`"
                      :url_image="false"
                      :bgColor="`#ed8e91`"
                      :size="1"
                    />
                  </div>
                  <CRow>
                    <CCol col="12">
                      <div class="font_setting">
                        <h2 :class="checkLangClass('h2')">
                          <b> {{ checkLanguage(content.title) }}</b>
                        </h2>
                        <p :class="checkLangClass('p')">
                          <b>{{ checkLanguage(content.subTitle) }}</b>
                        </p>
                      </div>
                    </CCol>
                  </CRow>
                </div>
                <CRow>
                  <CCol col="12">
                    <div class="block_btn">
                      <CRow>
                        <div class="button button_setting" v-on:click="onNext">
                          <CCol col="9">
                            <div class="font_size">START</div>
                          </CCol>
                          <CCol col="4">
                            <i
                              class="fas fa-caret-right fa-3x"
                              style="width: 50px; height: 50px"
                            ></i>
                          </CCol>
                        </div>
                      </CRow>
                    </div>
                  </CCol>
                </CRow>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Buttons from '../../../components/elements/Buttons/Button';
import ButtonIcon from '@/components/elements/Buttons/ButtonIcon';
import LoadingMDL from '@/components/loading/LoadingMDL';
import '../../../assets/scss/chinessStyle2.scss';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

export default {
  components: {Buttons, ButtonIcon, LoadingMDL, StepProgress},
  name: 'CIT01',
  props: {},
  data() {
    return {
      content: [],
      language: 'en',
      CheckWidth: window.innerWidth.toString(),
      action: [],
      loading: true,
      mySteps: [],
      currentStep: null,
      condition: [],
      startTime: '',
      criteria_id: '',
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      v3Data: null,
    };
  },
  methods: {
    onClose: function () {
      const str = this.action.close.action.split('-');

      const closePath = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(closePath);
    },
    onNext: function () {
      this.commitUserProgress();
    },
    checkLangClass(type) {
      if (type == 'h2') {
        if (this.language == 'CN') {
          return 'fontChinese font_h2';
        } else if (this.language == 'PIN IN') {
          return 'fontPinin font_h2';
        } else {
          return 'font_h2';
        }
      } else if (type == 'p') {
        if (this.language == 'CN') {
          return 'fontChinese font_p';
        } else if (this.language == 'PIN IN') {
          return 'fontPinin font_p';
        } else {
          return 'font_p';
        }
      }
    },
    commitUserProgress: function () {
      // this.loading = true;
      //commit dispatch
      // this.$store.dispatch('template/commitUserProgressChinese2', {
      //   code: this.code,
      //   contentId: this.criteria_id,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   topic: this.topic,
      //   chapter: this.chapter,
      //   condition: this.condition,
      // });

      // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);
      // //===========================================================

      const str = this.action.next.action.split('-');
      const nextPath = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(nextPath);
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
    setProgress: function (value) {
      return new Promise((resolve, reject) => {
        value.chapter.item.map((i) => {
          switch (i.content.type) {
            case 'topic':
              this.mySteps.push('Topic');
              break;
            case 'flipcard':
              this.mySteps.push('Vocabulary');
              break;
            case 'assignment':
              this.mySteps.push('Assignment');
              break;
            case 'test':
              this.mySteps.push('Test');
              break;
            default:
              this.mySteps.push(i.content.type);
              break;
          }
        });
        // value.checkPoints.map((i) => {
        //   if (i._id.topic == value.topicPosition.codeItem) {

        //   }
        // });
        this.currentStep = value.topicPosition.index - 1;
        resolve();
      });
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      this.mySteps = [];
      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content;
      this.action = template.navigate;

      this.loading = false;
    },
    // getTemplateAndProgress: async function (value) {
    //   this.mySteps = [];
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   this.criteria_id = value.criteria._id;
    //   this.chapter = value.chapter;
    //   this.topic = value.topicPosition;

    //   this.content = value.templateData.content;
    //   this.action = value.templateData.navigate;
    //   await this.setProgress(value);
    //   this.loading = false;
    // },
    // getResponseStatus: function (value) {
    //   if (value.status == 200) {
    //     if (this.action.next.action != '') {
    //       var str = this.action.next.action.split('-');
    //       let body = '/' + str[0] + '/' + str[1];
    //       this.$router.push(body);
    //     }
    //   }
    // },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {
    this.currentRoute = this.$route.name + '-' + this.$route.params.id;
    this.language = this.$store.getters['language/getLanguage'];
    this.courseData = this.$store.getters['necessary/getLerningCourse'];
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
    // this.getTemplate();
    this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
  },
  mounted() {
    // let payload = {
    //   templateCode: this.currentRoute,
    //   code: this.code,
    //   section: this.section,
    //   // section: "testing",
    // };
    // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
  },
  beforeDestroy() {
    //commit before destroy
  },
};
</script>

<style scoped lang="scss">
::v-deep .step-progress__wrapper-before {
  top: 45%;
  height: 10px;
  opacity: 0.5;
  background-color: #3b3b38 !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}

::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}

::v-deep .step-progress__wrapper-after {
  top: 45%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}

::v-deep .step-progress__step span {
  font-size: 0px;
}

::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}

::v-deep .step-progress__step-label {
  top: -50px;
}

::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}

::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}

::v-deep .step-progress__bar {
  margin-bottom: 10px;
  height: 6s0px;
}

.LS01_background {
  background-color: #e6efff;
}

.block_btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 19%;
  margin-right: 2%;
}

.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 5%;
}

.font_h2 {
  font-size: 50px;
}

.font_p {
  font-size: 20px;
}

.font_size {
  font-size: 25px;
}

.card {
  background-color: white;
  width: 1000px;
  height: 600px;
  margin-bottom: 12%;
  padding-top: 5%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
  /* 5px rounded corners */
}

.block {
  background-color: #e6efff;
  width: 100%;
  height: 250px;
  border-radius: 10px;
}

.font_setting {
  padding: 20px 20px 20px 20px;
  color: #1d5bd7;
}

.button_setting {
  width: 250px;
  height: 70px;
  background-color: #f1b205;
  color: white;
  text-align: right;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
}

.btn-exit {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 98%;
  z-index: 90;
}

* {
  user-select: none;
}

.container_CIT01 {
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 1%;
}

.ContentProgressBar {
  // padding-left: 40%;
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    margin-bottom: 3%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }

  // .progress-bar {
  //     background-color: #b3b3b3 !important;
  // }
}

.progress-bar-striped {
  background-image: none !important;
}

/* Add rounded corners to the top left and the top right corner of the image */
img {
  border-radius: 5px 5px 0 0;
}

.icon_btn {
  line-height: 20px;
  vertical-align: center;
  background-image: url('/icons/play-arrow.svg')
    no-repeat;
  background-size: contain;
}

@media screen and (min-width: 1000px) and (max-width: 1366px) {
  .position {
    padding-top: 8%;
  }

  .card {
    height: 500px;
    width: 850px;
  }

  .block_btn {
    margin-top: 10%;
  }

  .btn-exit {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 600px) and (min-width: 300px) {
  .position {
    padding-top: 30%;
    padding-bottom: 15%;
  }

  .button_setting {
    margin-top: 10px !important;
    width: 150px !important;
    height: 40px !important;
    font-size: 10px !important;
  }

  .block_btn {
    margin-right: 5%;
  }

  .card {
    width: 300px;
    height: 400px;
  }

  .font_setting {
    font-size: 20px;
  }

  .font_p {
    font-size: 18px;
  }

  .font_h2 {
    font-size: 25px;
  }

  .btn-exit {
    width: 60px !important;
    height: 60px !important;
    padding: 10px;
    left: 93%;
  }

  .font_size {
    font-size: 12px;
  }
}

// responsive ipad
@media screen and (min-width: 700px) and (max-width: 1023px) {
  .position {
    padding-top: 10%;
  }

  .card {
    width: 600px;
    height: 400px;
    margin-bottom: 15%;
  }

  .font_p {
    font-size: 20px;
  }

  .font_h2 {
    font-size: 35px;
  }

  .font_size {
    font-size: 20px;
  }

  .button_setting {
    width: 200px !important;
    height: 50px !important;
  }

  .block_btn {
    margin-top: 8%;
    margin-right: 3%;
  }

  .btn-exit {
    width: 70px !important;
    height: 70px !important;
    padding: 10px;
    left: 95%;
  }
}
</style>
